import css from "@emotion/css";

export const linkBody = css`
  font-weight: 700;
  color: #0075d1;
  &:hover {
    color: #005192;
  }
`;
